import { render, staticRenderFns } from "./ExportCKLModal.vue?vue&type=template&id=8834b128"
import script from "./ExportCKLModal.vue?vue&type=script&lang=ts"
export * from "./ExportCKLModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports